import React, { useState } from 'react';
import {Button, Container} from "react-bootstrap";
import {useNavigate} from "react-router-dom";

function Login() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const navigate = useNavigate();
    const handleRegisterRedirect = () => {
        navigate('/register');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!username || !password) {
            setError('Prosím, vyplňte obě pole.');
            return;
        }

        try {
            const response = await fetch('https://api.lexikonn.eu/mau/login.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify({ username, password }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || 'Přihlášení selhalo.');
            }
            localStorage.setItem('mau_user', data.user);
            localStorage.setItem('mau_user_type', data.user_type);
            localStorage.setItem('mau_user_name', data.user_name);
            localStorage.setItem('mau_user_img', data.user_img);
            window.location.href = "/"

        } catch (error) {
            setError(error.message);
        }
    };

    return (
        <Container>
            <div className="mt-5">
                <div className="lead mb-3">Přihlášení</div>
                {error && <div className="text-danger mb-3">{error}</div>}
                <form onSubmit={handleSubmit}>
                    <input
                        className="form-control mb-3"
                        type="text"
                        name="username"
                        placeholder="Jméno"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                    <input
                        className="form-control mb-3"
                        type="password"
                        name="password"
                        placeholder="Heslo"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <div className="text-center">
                        <button className="btn btn-success" type="submit"><i className="bi bi-box-arrow-in-right"></i> Přihlásit
                        </button>
                    </div>
                </form>
            </div>
            <div className="text-center">
                <div>
                    <Button style={{ color: "black", textDecoration: "none" }}
                        variant="link"
                        onClick={handleRegisterRedirect}
                    >
                        Ještě nemám účet
                    </Button>
                </div>
            </div>
        </Container>
    );
}

export default Login;
